import { useState, useCallback } from 'react';
import { CLASSIC_RIVALS, pickClassicRival, rivalCharacter } from './four12Characters';

// Rival del modo clásico vs bot: el bot o uno de los 5 personajes de 412.
//
// `choice` es lo que eligió el jugador en el selector: 'random' (default) sortea un rival
// distinto en cada partida; un id fijo juega siempre contra ese. La elección se recuerda entre
// visitas (localStorage, solo como comodidad: si no anda, vuelve a 'random').
//
// Con `enabled` en false (otros modos) devuelve character null y el resto no se usa.

export const RANDOM_RIVAL = 'random';
const STORAGE_KEY = 'footy.classicBotRival';

const isValidChoice = (v) => v === RANDOM_RIVAL || CLASSIC_RIVALS.some(r => r.id === v);

const readStoredChoice = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return isValidChoice(v) ? v : RANDOM_RIVAL;
  } catch {
    return RANDOM_RIVAL;
  }
};

export default function useClassicRival(enabled) {
  const [{ choice, rivalId }, setState] = useState(() => {
    const stored = readStoredChoice();
    return { choice: stored, rivalId: stored === RANDOM_RIVAL ? pickClassicRival() : stored };
  });

  // Elegir uno fijo lo pone en cancha al toque; volver a aleatorio deja al actual hasta la
  // próxima partida (cambiarlo en medio de una no aporta nada).
  const setChoice = useCallback((next) => {
    if (!isValidChoice(next)) return;
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* sin storage: no se recuerda */ }
    setState(prev => ({ choice: next, rivalId: next === RANDOM_RIVAL ? prev.rivalId : next }));
  }, []);

  // Se llama al empezar cada partida nueva.
  const nextRound = useCallback(() => {
    setState(prev => (prev.choice === RANDOM_RIVAL
      ? { ...prev, rivalId: pickClassicRival(prev.rivalId) }
      : prev));
  }, []);

  return {
    choice,
    setChoice,
    nextRound,
    character: enabled ? rivalCharacter(rivalId) : null,
  };
}
